<template>
  <div>
    <van-nav-bar title="我的审批" @click-left="clickBack" left-arrow />
    <van-tabs sticky color="#1989fa" line-height="2px" line-width="50px">
      <van-tab title="预约审批">
        <div class="list">
          <div class="todo-list" v-if="todoAuditList.length > 0">
            <div
              class="todo-list-item flex"
              v-for="(item, index) in todoAuditList"
              :key="index"
              @click="handlelist(item.id)"
            >
              <div class="todo-left">
                <div class="date">{{ item.resttime }}</div>
                <div class="date-course">
                  {{ item.startTime }} - {{ item.endTime }}
                </div>
              </div>
              <div class="todo-content flex-1">
                <div class="flex">
                  <div>{{ item.affiliatedUnit }}</div>
                </div>
                <div class="info" style="margin: 0.5rem 0;">
                  {{ item.initiatorName }} {{ item.initiatorPhone }}
                </div>
                <div class="person">
                  <span v-for="(v, index) in item.visitorName" :key="index">
                    {{ v }}
                    <span v-if="index !== item.visitorName.length - 1">
                      /
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <van-empty description="暂无数据" />
          </div>
        </div>
      </van-tab>
      <van-tab title="请假审批"><leaveAudit /></van-tab>
      <van-tab title="代接送审批"><pickupAudit /></van-tab>
      <!-- <van-tab title="进出审批"><accessAudit /></van-tab> -->
    </van-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import leaveAudit from '../LeaveCommand/leaveAudit'
import pickupAudit from '../PickUpStation/pickupAudit'
import accessAudit from '../Access/accessAudit'
export default {
  data() {
    return {
      todoAuditList: [],
    }
  },
  mounted() {
    this.getList()
  },
  components: {
    leaveAudit,
    pickupAudit,
    accessAudit,
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    handlelist(id) {
      this.$router.push({ path: '/detailSub', query: { id, type: 'approval' } })
    },
    async getList() {
      const { data, code, msg } = await this.$https.getAuditList({
        auditType: '',
        userId: this.$store.state.userId,
      })
      if (code !== 200) {
        this.$toast(msg)
        return false
      }
      this.todoAuditList = this.normalData(data)
    },
    normalData(data) {
      return data.map((item) => {
        item.resttime = moment(item.visitorBeginTime).format('YYYY.MM.DD')
        item.startTime = moment(item.visitorBeginTime).format('HH:mm')
        item.endTime = moment(item.visitorEndTime).format('HH:mm')
        return item
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-list {
  background: #fff;
  border-radius: 1.0625rem;
  margin-top: 0.8125rem;
  /* padding: 1.5rem 0; */
  margin: 1rem;

  .todo-list-item {
    padding: 1rem 0;
    margin: 0 0.75rem;
    color: #959dad;
    position: relative;
    align-items: center;
    border-bottom: 1px solid #f4f4f6;
    &:last-child {
      margin-bottom: 0;
    }
    .todo-left {
      flex-direction: column;
      align-items: center;
      .todo {
        background: rgba(52, 151, 253, 1);
        width: 1.5rem;
        height: 1.5rem;
        color: #fff;
        text-align: center;
        line-height: 1.5rem;
        font-size: 0.75rem;
        border-radius: 0.5rem;
        margin-bottom: 0.625rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .date {
        margin-bottom: 0.3125rem;
        font-size: 0.75rem;
        font-weight: 400;
        color: rgba(120, 132, 158, 1);
      }
      .date-course {
        font-size: 0.5625rem;
      }
    }
  }
  .todo-content {
    font-size: 0.75rem;
    font-weight: 400;
    margin-left: 0.5rem;
    .person {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 12rem;
    }
    .info {
      /* margin-top: 0.25rem; */
    }
    .avatar {
      margin-top: 0.4875rem;
      /* text-overflow; */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 12rem;
    }
    img {
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      margin-right: 0.5rem;
      object-fit: cover;
    }
  }
  .todo-btn {
    width: 2.6875rem;
    height: 2.6875rem;
    text-align: center;
    line-height: 2.6875rem;
    font-size: 0.75rem;
    border-radius: 0.5rem;
    color: #fff;
    margin-left: 0.3rem;
    box-shadow: 0 0.75rem 1rem rgba(69, 91, 99, 0.1);
    background: #3acce1;

    /* margin-right: 0.75rem; */
  }
  .do-btn {
    position: absolute;
    width: 3rem;
    height: 1.875rem;
    border: 1px solid #3acce1;
    color: #3acce1;
    text-align: center;
    line-height: 1.875rem;
    right: 1rem;
    font-size: 0.8rem;
    transform: rotate(30deg);
  }
}
</style>
